import React from 'react'
import { FormattedMessage } from 'react-intl'
import { goToPost } from 'actions/posts'
import Link from 'redux-first-router-link'
import ArticleSummary from 'components/ArticleSummary'
import StarMeter from 'components/StarMeter'
import styles from './ReactionActivity.css'

const Reactions = ({ reactions }) => {
  return (
    <div className={styles.reactions}>
      {Object.getOwnPropertyNames(reactions).map(reaction => {
        let r = reactions[reaction]
        let rating = r.total_rating / r.number_of_ratings
        return (
          <div key={reaction}>
            <FormattedMessage id={`post.reactions.${reaction}`} />
            <StarMeter rating={rating} readonly={true} />
          </div>
        )
      })}
    </div>
  )
}

const ReactionActivity = ({ post, author }) => {
  if (post && author) {
    return (
      <div className={styles.reaction_activity}>
        <Link
          to={goToPost({
            _id: post._id,
            group: post.group,
            name: post.name,
            username: author.username
          })}
          className={styles.article}
        >
          <ArticleSummary article={{ ...post, author }} />
        </Link>
        <Reactions reactions={post.reactions} />
      </div>
    )
  } else {
    return null
  }
}

export default ReactionActivity
